﻿import { AdminMetricCard } from "@/components/admin";
import type { AdminStatusTone } from "@/lib/adminCodeDisplay";
import type { DeviceItem } from "@/types.ts";

interface DeviceSummaryCardsProps {
  devices: DeviceItem[];
}

interface DeviceSummaryCard {
  title: string;
  value: string;
  badge: string;
  description: string;
  tone: AdminStatusTone;
  icon: string;
}

const countByStatus = (devices: DeviceItem[], status: string) => {
  return devices.filter((device) => device.status === status).length;
};

const DeviceSummaryCards = ({ devices }: DeviceSummaryCardsProps) => {
  const total = devices.length;
  const active = countByStatus(devices, "ACTIVE");
  const inactive = countByStatus(devices, "INACTIVE");
  const revoked = countByStatus(devices, "REVOKED");
  const cards: DeviceSummaryCard[] = [
    { title: "전체 기기", value: `${total}대`, badge: "등록", description: "관리 대상 등록 기기", tone: "slate", icon: "ri-router-line" },
    { title: "활성 기기", value: `${active}대`, badge: "사용", description: "현재 사용 가능 상태", tone: "emerald", icon: "ri-wifi-line" },
    { title: "비활성 기기", value: `${inactive}대`, badge: "확인", description: "운영 확인이 필요한 상태", tone: "orange", icon: "ri-error-warning-line" },
    { title: "해제 기기", value: `${revoked}대`, badge: "제외", description: "사용 해제 처리된 기기", tone: "red", icon: "ri-forbid-2-line" },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map((card) => (
        <AdminMetricCard
          key={card.title}
          title={card.title}
          value={card.value}
          badge={card.badge}
          description={card.description}
          tone={card.tone}
          icon={card.icon}
        />
      ))}
    </div>
  );
};

export default DeviceSummaryCards;
